import React from 'react'

const SubNav = ({items, onNav, currentPath}) => (
  <nav className="subnav">
    {items && items.map((item, i) => {
      let active = false;
      if(item.parent) {
        if(currentPath.indexOf(item.parent)>=0) {
          active = true;
        }
      }
      if (!item.hidden) {
        return(
          <a className={active ? 'active' : null} href={item.link} key={`navlink_${i}`} onClick={() => onNav()}>{item.title}</a>
        )
      }
      return null;
    })}
  </nav>
);

export default SubNav



// WEBPACK FOOTER //
// ./src/components/SubNav.js